'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useEffect, startTransition } from 'react';
import { Menu, X, Search, Moon, Sun, User, LogOut, LayoutDashboard } from 'lucide-react';
import { useTheme } from 'next-themes';
import { CATEGORIES } from '@/lib/categories';
import { useAuth } from '@/components/auth/AuthProvider';
export function Header() {
  const $ = _c(46);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    theme,
    setTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  const {
    user,
    isAdmin,
    login,
    logout
  } = useAuth();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 20);
      };
      startTransition(() => {
        setMounted(true);
      });
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = `sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-lg border-b border-gray-200 dark:border-gray-800 shadow-sm" : "bg-transparent"}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/" className="flex items-center space-x-2 group"><div className="w-10 h-10 rounded-lg gradient-primary flex items-center justify-center transform group-hover:scale-105 transition-transform"><span className="text-white font-bold text-xl">T</span></div><span className="font-bold text-xl md:text-2xl gradient-text-primary">Tech-Knowlogia</span></Link>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">Home<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
    t5 = CATEGORIES.map(_temp);
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/about" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">About<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden md:flex items-center space-x-8">{t4}{t5}{t6}<Link href="/contact" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">Contact<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button aria-label="Search" className="p-2 rounded-lg hover:bg-muted transition-colors"><Search className="w-5 h-5" /></button>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== mounted || $[9] !== setTheme || $[10] !== theme) {
    t9 = mounted && <button onClick={() => setTheme(theme === "dark" ? "light" : "dark")} aria-label="Toggle theme" className="p-2 rounded-lg hover:bg-muted transition-colors">{theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}</button>;
    $[8] = mounted;
    $[9] = setTheme;
    $[10] = theme;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isAdmin || $[13] !== login || $[14] !== logout || $[15] !== user) {
    t10 = user ? <div className="flex items-center space-x-2">{isAdmin && <Link href="/admin-dashboard" className="p-2 rounded-lg hover:bg-muted transition-colors text-primary" title="Admin Dashboard"><LayoutDashboard className="w-5 h-5" /></Link>}<button onClick={logout} className="p-2 rounded-lg hover:bg-muted transition-colors text-red-500" title="Logout"><LogOut className="w-5 h-5" /></button></div> : <button onClick={login} className="p-2 rounded-lg hover:bg-muted transition-colors" title="Login"><User className="w-5 h-5" /></button>;
    $[12] = isAdmin;
    $[13] = login;
    $[14] = logout;
    $[15] = user;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/newsletter" className="px-4 py-2 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors">Subscribe</Link>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t9) {
    t12 = <div className="hidden md:flex items-center space-x-4">{t8}{t9}{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isMenuOpen) {
    t13 = () => setIsMenuOpen(!isMenuOpen);
    $[21] = isMenuOpen;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isMenuOpen) {
    t14 = isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />;
    $[23] = isMenuOpen;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <button onClick={t13} className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors" aria-label="Toggle menu">{t14}</button>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <div className="flex items-center justify-between h-16 md:h-20">{t3}{t7}{t12}{t15}</div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== isAdmin || $[32] !== isMenuOpen || $[33] !== login || $[34] !== logout || $[35] !== mounted || $[36] !== setTheme || $[37] !== theme || $[38] !== user) {
    t17 = isMenuOpen && <div className="md:hidden border-t border-gray-200 dark:border-gray-800"><div className="py-4 space-y-4"><Link href="/" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Home</Link>{CATEGORIES.map(category_0 => <Link key={category_0.slug} href={`/${category_0.slug}`} className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>{category_0.name}</Link>)}<Link href="/about" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>About</Link><Link href="/contact" className="block px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Contact</Link>{user ? <>{isAdmin && <Link href="/admin-dashboard" className="block px-4 py-2 text-sm font-medium text-primary hover:bg-muted rounded-lg transition-colors" onClick={() => setIsMenuOpen(false)}>Admin Dashboard</Link>}<button onClick={() => {
            logout();
            setIsMenuOpen(false);
          }} className="block w-full text-left px-4 py-2 text-sm font-medium text-red-500 hover:bg-muted rounded-lg transition-colors">Logout</button></> : <button onClick={() => {
          login();
          setIsMenuOpen(false);
        }} className="block w-full text-left px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors">Login</button>}<div className="flex items-center space-x-4 px-4 pt-4 border-t border-gray-200 dark:border-gray-800"><button aria-label="Search" className="p-2 rounded-lg hover:bg-muted transition-colors"><Search className="w-5 h-5" /></button>{mounted && <button onClick={() => setTheme(theme === "dark" ? "light" : "dark")} aria-label="Toggle theme" className="p-2 rounded-lg hover:bg-muted transition-colors">{theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}</button>}</div><div className="px-4"><Link href="/newsletter" className="block w-full px-4 py-2 text-center rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors" onClick={() => setIsMenuOpen(false)}>Subscribe</Link></div></div></div>;
    $[31] = isAdmin;
    $[32] = isMenuOpen;
    $[33] = login;
    $[34] = logout;
    $[35] = mounted;
    $[36] = setTheme;
    $[37] = theme;
    $[38] = user;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17) {
    t18 = <nav className="container">{t16}{t17}</nav>;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18 || $[44] !== t2) {
    t19 = <header className={t2}>{t18}</header>;
    $[43] = t18;
    $[44] = t2;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}
function _temp(category) {
  return <Link key={category.slug} href={`/${category.slug}`} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">{category.name}<span className="absolute inset-x-0 -bottom-1 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform origin-left" /></Link>;
}